import { Component, output } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
@Component({
  selector: 'app-modal-permission',
  standalone: true,
  imports: [],
  templateUrl: './modal-permission.component.html',
  styleUrl: './modal-permission.component.scss'
})
export class ModalPermissionComponent {
  data!: { type: "mic" | "cam" , into: "chat" | "meeting" | "call" }
  onSubmitOutput = output();

  MESSAGE_MAP: Record<
    "chat" | "meeting" | "call",
    Record<"mic" | "cam" , string>
  > = {
    chat: {
      mic: 'ghi âm tin nhắn thoại',
      cam: 'ghi hình'
    },
    meeting: {
      mic: 'ghi âm trong cuộc họp',
      cam: 'ghi hình trong cuộc họp'
    },
    call: {
      mic: 'thực hiện cuộc gọi',
      cam: 'thực hiện cuộc gọi',
    }
  };

  get messageCustom(): string {
    if (!this.data) return '';
    return this.MESSAGE_MAP[this.data.into][this.data.type];
  }

  constructor(
    private modalRef: NzModalRef) {
    if (this.modalRef) {
      this.data = this.modalRef.getConfig().nzData;
    }
  }

  onSubmit(): void {
    this.onSubmitOutput.emit();
    this.onCancel();
  }

  onCancel(): void {
    this.modalRef.close();
  }
}
